<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" label />

    <!--협의체 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 협의체 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>협의일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <date-selector v-else v-model="form.inputA_2" :readonly="board.readonly" />
        </div>
        <div>
          <div>회의장소</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_3 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputA_3" />
        </div>
        <div>
          <div>노측 위원(명)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_4 }}</p>
          <comma-input :readonly="board.readonly" v-else type="number" v-model="form.inputA_4" />
        </div>
        <div>
          <div>사측 위원(명)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_5 }}</p>
          <comma-input :readonly="board.readonly" v-else type="number" v-model="form.inputA_5" />
        </div>
      </div>
    </div>

    <!-- 노·사협의체(사용자) -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="사측 위원(사용자)"
      :tableData="[
        { id: 'cell1', title: '소속명', type: 'text' },
        { id: 'cell2', title: '직책', type: 'select', selectData: ['사용자대표', '안전관리자', '보건관리자', '관리감독자', '사용자위원', '기타'] },
        { id: 'cell3', title: '이름', type: 'text' },
        { id: 'cell4', title: '서명', type: 'sign' },
        { id: 'cell5', title: '비고', type: 'text' },
      ]"
      :mobile="['cell1', 'cell3']"
      v-model="form.userTableList"
      class="mt-28px"
    />

    <!-- 노측 위원(근로자) -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="사측 위원(사용자)"
      :tableData="[
        { id: 'cell1', title: '소속명', type: 'text' },
        { id: 'cell2', title: '직책', type: 'select', selectData: ['근로자대표', '명예산업안전감독관', '근로자위원', '기타'] },
        { id: 'cell3', title: '이름', type: 'text' },
        { id: 'cell4', title: '서명', type: 'sign' },
        { id: 'cell5', title: '비고', type: 'text' },
      ]"
      :mobile="['cell1', 'cell3']"
      v-model="form.workerTableList"
      class="mt-28px"
    />

    <!-- 노·사협의체(심의·의결사항, 안전계획 등) 협의내용  -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 노·사협의체(심의·의결사항, 안전계획 등) 협의내용</h5>

      <div class="writeGridContainer">
        <div>
          <div>대상기간</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }} ~ {{ form.inputB_2 }}</p>
          <div v-else class="time">
            <date-selector v-model="form.inputB_1" :readonly="board.readonly" />
            <p>~</p>
            <date-selector v-model="form.inputB_2" :readonly="board.readonly" />
          </div>
        </div>
        <div>
          <div>재해형태(필수)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>
          <disaster-class-selector v-else v-model="form.inputB_3" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>노·사협의체 구성</div>
          <p v-if="isPrint" class="print-textarea">{{ form.inputB_4 }}</p>
          <ml-textarea v-else rows="5" v-model="form.inputB_4" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>노·사협의체 운영</div>
          <p v-if="isPrint" class="print-textarea">{{ form.inputB_5 }}</p>
          <ml-textarea v-else rows="5" v-model="form.inputB_5" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>노·사합동안전점검</div>
          <p v-if="isPrint" class="print-textarea">{{ form.inputB_6 }}</p>
          <ml-textarea v-else rows="5" v-model="form.inputB_7" :readonly="board.readonly" />
        </div>
        <div>
          <div>작업시간</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_8 }}</p>
          <time-selector v-else v-model="form.inputB_8" />
        </div>
        <div class="writeGridLineItem">
          <div>작업장 간의 연락방법</div>
          <p v-if="isPrint" class="print-textarea">{{ form.inputB_9 }}</p>
          <ml-textarea v-else rows="5" v-model="form.inputB_9" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>산업재해 예방계획 수립에 관한 사항</div>
          <p v-if="isPrint" class="print-textarea">{{ form.inputB_10 }}</p>
          <ml-textarea v-else rows="5" v-model="form.inputB_10" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>안전보건관리규정 작성 및 변경 사항</div>
          <p v-if="isPrint" class="print-textarea">{{ form.inputB_11 }}</p>
          <ml-textarea v-else rows="5" v-model="form.inputB_11" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>근로자의 안전보건교육 사항</div>
          <p v-if="isPrint" class="print-textarea">{{ form.inputB_12 }}</p>
          <ml-textarea v-else rows="5" v-model="form.inputB_12" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="점검 현장 사진" class="mt-28px" />

    <!-- 파일첨부 -->
    <file-upload-module v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" class="mt-28px"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector";
import TimeSelector from "@/components/selector/TimeSelector";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FieldSelector from "@/components/selector/FieldSelector";
import TableCustom from "@/components/TableCustom";

export default {
  components: {
    FieldSelector,
    FieldSelectModule,
    DateSelector,
    TimeSelector,
    PhotoUploadGridModule,
    FileUploadModule,
    DisasterClassSelector,
    TableCustom,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.summary = {
          노사협의체_사업장명: [],
          노사협의체_재해형태: [],
        };

        value.summary["노사협의체_사업장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        value.summary["노사협의체_재해형태"].push({
          [this.form.inputB_3]: 1,
        });

        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        userTableList: [],
        workerTableList: [],
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",
        inputB_9: "",
        inputB_10: "",
        inputB_11: "",
        inputB_12: "",
        photoList: [],
        fileList: [],
        fieldTitle: "",
      },
    };
  },
};
</script>
